<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
        :props="props" :titles="titles" :form="form" :bus="bus" icons="1">

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
            v-model="form.name" :error="errors.name" required="1">
        </trax-ui-input>

        <trax-ui-input type="text" icon="text_fields" rows="3" :placeholder="lang.polaris.form.description"
            v-model="form.description" :error="errors.description">
        </trax-ui-input>

        <trax-ui-select icon="insert_photo" v-model="form.background" :options="backgrounds_select">
        </trax-ui-select>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: {
            bus: null,
            id: null,
            toastrId: null,
            endpoint: null
        },
    
        data: function() {
            return {
                lang: lang,
                form: {},
                errors: {},
                backgrounds_select: data.backgrounds_select,
                props: {
                    id: { source:'id' },
                    type: { source:'type', default: 'standard-course' },
                    name: { source:'data.name' },
                    description: { source:'data.description' },
                    order: { source:'data.order' },
                    background: { source:'data.background', default: 'default.jpg' }
                },
                titles: {
                    new: lang.polaris.training.new_course,
                    update: lang.polaris.training.course_update
                }
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data) {
                that.form = data;
            });
        }

    }
</script>
